// 快訊頁日曆時間軸
import { useLayoutEffect, useRef, useEffect } from 'react';
import FlashCalendarComponent from './FlashCalendarComponent';

const FlashCalendarTimeline = ({ list, setSelectedDate, selectedDate }) => {
    const scrollRef = useRef(null);

    const handleScroll = () => {
        const left = (scrollRef.current.scrollWidth - scrollRef.current.offsetWidth) / 2;
        scrollRef.current.scrollTo({ left, behavior: 'auto' }); // 使用 'auto' 避免滾動動畫
    };

    useLayoutEffect(() => {
        if (scrollRef.current) handleScroll();
    }, []);

    useEffect(() => {
        window.addEventListener('resize', handleScroll);

        return () => window.removeEventListener('resize', handleScroll);
    }, []);

    return (
        <div
            ref={scrollRef}
            className="relative w-full mt-[5px] h-[132px] noScrollX ulg:w-screen ulg:left-[50%] ulg:translate-x-[-50%] ulg"
        >
            <div className="relative flex items-center gap-x-[10px] w-max usm:px-[15px]">
                {Object.keys(list)?.map((date, i) => (
                    <div
                        key={'calendar' + date + i}
                        className="[&>div]:w-[106px] [&>div]:flex-shrink-0"
                        onClick={() => {
                            setSelectedDate(date);
                        }}
                    >
                        <FlashCalendarComponent
                            v={list?.[date]}
                            date={date}
                            selectedDate={selectedDate}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FlashCalendarTimeline;
